//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import DialogFormEdit from "@/0/components/comForm/comDialog/comDialogFormEdit2";
import ActionSheet from "@/0/components/comForm/comControls/comActionSheet.vue";
import ActionPicker from "@/0/components/comForm/comControls/comActionPicker.vue";
import PageEnd from "@/0/components/0.comPage/05.comPageEnd.vue";

export default {
  components: {
    "action-sheet": ActionSheet,
    "action-picker": ActionPicker,
    "dialog-form-edit": DialogFormEdit,
    "page-end": PageEnd
  },
  props: [],
  data() {
    return {
      isShow : true,
      ButtonList: [],
    };
  },
  methods: {
    Show(){
      this.$show();
    },
    
    Hide(){
      this.$hide();
    },

    $show(){
      this.isShow = true;
    },

    $hide(){
      this.isShow = false;
    },

    $getThisForm(){
      return this.$parent;
    },

    $getActionObj(){

      var actionObj = {
        getComActionSheet : ()=>{
          return this.$refs.comActionSheet;
        },          
        getComActionPicker : ()=>{
          return this.$refs.comActionPicker;
        },        
        getComDialogFormEdit : ()=>{
          return this.$refs.comDialogFormEdit;
        },
        getComFormEdit : ()=>{
          var comFormEdit = this.$parent.getComFormEdit();
          return comFormEdit;
        },
        getComPageEdit : ()=>{
          var comPage = this.$parent;
          return comPage;
        },
        getComPage : ()=>{
          var comPage = this.$parent;
          return comPage;
        },
        getComPageEnd : ()=>{
          return this.$refs.comPageEnd;
        },

        getSubmitData : ()=>{

          var postData = null;
          try{
            postData = this.$parent.$getSubmitData();
            //console.log("postData",postData);
          }catch(e){
            console.log("getSubmitData=====e",e);
          }         

          return postData;
        },
      };

      return actionObj;
    },

    setData(operateList) {
      if (!operateList) return;

      var buttonList = operateList.ButtonList;
      if (!buttonList || buttonList.length == 0) return;

      if(this.ButtonList.length > 0){
        this.ButtonList.splice(0,this.ButtonList.length);
      }

      var that = this;

      var actionObj = this.$getActionObj();

      buttonList.forEach(m => {
        var skinType = "primary";
        if (m.SkinType) {
          skinType = m.SkinType;
        }

        var buttonItem = {
          Type: skinType,
          Text: m.Text,
          DataItem: m,
          OnClick: async buttonItem => {
            var btnDataItem = buttonItem.DataItem;

            await this.$cmd.ExecuteCmd(btnDataItem,actionObj);

          }
        };

        this.addButton(buttonItem);
      });
    },

    addButton(buttonItem) {
      var thisIndex = this.ButtonList.findIndex(
        m => m.Text == buttonItem
      );
      if (thisIndex != -1) {
        return;
      }
      this.ButtonList.push(buttonItem);
    },

    onButtonClick(buttonItem) {
      if (buttonItem && buttonItem.OnClick) {
        buttonItem.OnClick(buttonItem);
      }
    }
  }
};
